import * as React from "react";

function SvgRejected(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 9.914l-4.293 4.293-1.414-1.414L6.586 8.5 2.293 4.207l1.414-1.414L8 7.086l4.293-4.293 1.414 1.414L9.414 8.5l4.293 4.293-1.414 1.414L8 9.914z"
        fill="#D83156"
      />
    </svg>
  );
}

export default SvgRejected;
